








































import PStorage from '@/util/PStorage'
import { Vue, Component } from 'vue-property-decorator'

@Component({ name: 'secret-key' })
export default class SecretKey extends Vue {
    public getSecretKey(): string[] {
        return PStorage.get('secret_key').split('-')
    }
}
